import { render, staticRenderFns } from "./AppListItemWide.vue?vue&type=template&id=5431d1a1"
import script from "./AppListItemWide.vue?vue&type=script&lang=js"
export * from "./AppListItemWide.vue?vue&type=script&lang=js"
import style0 from "./AppListItemWide.vue?vue&type=style&index=0&id=5431d1a1&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports